import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Input } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useState, useEffect } from "react";

function CommonPackingList(props) {
  const defaultLeftSideData = [
    { slNo: "1", description: "أمتعه شخصيه", quantity: "10" },
    { slNo: "2", description: "ملابس مستعمله", quantity: "20" },
    { slNo: "3", description: "شانبو", quantity: "10" },
    { slNo: "4", description: "أدوات تجميل", quantity: "5" },
    { slNo: "5", description: "بطانية", quantity: "2" },
    { slNo: "6", description: "عباية", quantity: "2" },
    { slNo: "7", description: "سجاد", quantity: "20" },
    { slNo: "8", description: "تائج عصير", quantity: "5" },
    { slNo: "9", description: "احذيه", quantity: "3" },
    { slNo: "10", description: "ملابس جديد", quantity: "4" },
    { slNo: "11", description: "اداوات مطبخ", quantity: "10" },
    { slNo: "12", description: "بنطلون رجالي", quantity: "3" },
    { slNo: "13", description: "قميص رجالي", quantity: "3" },
    { slNo: "14", description: "جاكيت رجالي", quantity: "3" },
    { slNo: "15", description: "حليب نيدو", quantity: "1" },
    { slNo: "16", description: "حلويات", quantity: "5" },
    { slNo: "17", description: "", quantity: "" },
    { slNo: "18", description: "", quantity: "" },
    { slNo: "19", description: "", quantity: "" },
  ];

  const defaultRightSideData = [
    { slNo: "20", description: "", quantity: "" },
    { slNo: "21", description: "", quantity: "" },
    { slNo: "22", description: "", quantity: "" },
    { slNo: "23", description: "", quantity: "" },
    { slNo: "24", description: "", quantity: "" },
    { slNo: "25", description: "", quantity: "" },
    { slNo: "26", description: "", quantity: "" },
    { slNo: "27", description: "", quantity: "" },
    { slNo: "28", description: "", quantity: "" },
    { slNo: "29", description: "", quantity: "" },
    { slNo: "30", description: "", quantity: "" },
    { slNo: "31", description: "", quantity: "" },
    { slNo: "32", description: "", quantity: "" },
    { slNo: "33", description: "", quantity: "" },
    { slNo: "34", description: "", quantity: "" },
    { slNo: "35", description: "", quantity: "" },
    { slNo: "36", description: "", quantity: "" },
    { slNo: "37", description: "", quantity: "" },
  ];

  // State for editable quantities
  const [editableLeftData, setEditableLeftData] = useState(defaultLeftSideData);
  const [editableRightData, setEditableRightData] =
    useState(defaultRightSideData);
  const [isEditing, setIsEditing] = useState(true);

  // Initialize editable data when component mounts
  useEffect(() => {
    setEditableLeftData(defaultLeftSideData);
    setEditableRightData(defaultRightSideData);
  }, []);

  // Handle left side quantity change
  const handleLeftQuantityChange = (index, value) => {
    const newData = [...editableLeftData];
    newData[index].quantity = value;
    setEditableLeftData(newData);
  };

  // Handle right side quantity change
  const handleRightQuantityChange = (index, value) => {
    const newData = [...editableRightData];
    newData[index].quantity = value;
    setEditableRightData(newData);
  };

  const leftTableData = props?.selected?.packingList?.left || editableLeftData;
  const rightTableData =
    props?.selected?.packingList?.right || editableRightData;

  const billOfLading = `${props?.selected?.awb_no || ""} - ${
    props?.selected?.airline || ""
  }`;
  const numberOfPackages = props?.selected?.psc || "";
  const weight = props?.selected?.chargable_weight || "";

  const handlePrint = () => {
    // Temporarily set to non-editing mode for print
    setIsEditing(false);

    setTimeout(() => {
      const printContent = document.getElementById("packing-list-content");

      const printWindow = window.open("", "_blank", "width=800,height=600");

      const contentToPrint = printContent.innerHTML;

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Packing List</title>
            <style>
                             body {
                 font-family: Arial, sans-serif;
                 direction: rtl;
                 text-align: right;
                 padding: 40px;
                 margin: 0;
                 min-height: 100vh;
               }
              table {
                width: 100%;
                border-collapse: collapse;
                border: 1px solid lightgray;
                direction: rtl;
              }
              th, td {
                border: 1px solid lightgray;
                padding: 6px 4px;
                text-align: center;
                font-size: 12px;
              }
              th {
                background-color: #f0f0f0;
                font-weight: bold;
                font-size: 13px;
              }
              .header {
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 30px;
                padding-bottom: 10px;
              }
              .address, .purpose, .shipment-details {
                font-size: 16px;
                margin-bottom: 15px;
                line-height: 1.8;
              }
              .shipment-details {
                margin-bottom: 30px;
              }
                             @media print {
                 body {
                   padding: 30px;
                   margin: 0;
                 }
               }
            </style>
          </head>
          <body>
            ${contentToPrint}
          </body>
        </html>
      `);

      printWindow.document.close();

      // Wait for content to load then print
      printWindow.onload = function () {
        printWindow.print();
        printWindow.close();
        // Restore editing mode after print
        setIsEditing(true);
      };
    }, 100);
  };

  // PDF Download function
  const handleDownloadPDF = async () => {
    // Temporarily set to non-editing mode for PDF
    setIsEditing(false);

    setTimeout(async () => {
      const element = document.getElementById("packing-list-content");
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`packing-list-${props?.selected?.awb_no || "document"}.pdf`);

      // Restore editing mode after PDF generation
      setIsEditing(true);
    }, 100);
  };
  return (
    <Modal
      visible={props.visible}
      onCancel={props.onClose}
      footer={
        <div
          style={{
            display: "flex",
          }}
        >
          <Space>
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              style={{ direction: "ltr" }}
            >
              Print
            </Button>
            <Button
              type="default"
              icon={<DownloadOutlined />}
              onClick={handleDownloadPDF}
              style={{ direction: "ltr" }}
            >
              Download PDF
            </Button>
          </Space>
        </div>
      }
      width={800}
      style={{ direction: "rtl" }}
    >
      <div
        id="packing-list-content"
        style={{
          fontFamily: "Arial, sans-serif",
          direction: "rtl",
          textAlign: "right",
          padding: "40px",
          minHeight: "100vh",
        }}
      >
        {/* Header - Center aligned */}
        <div
          style={{
            textAlign: "center",
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "30px",
            paddingBottom: "10px",
          }}
        >
          بيانتعبئه
        </div>

        {/* Address Section - Right aligned */}
        <div
          style={{
            textAlign: "right",
            fontSize: "16px",
            marginBottom: "15px",
            lineHeight: "1.8",
          }}
        >
          <div>سعادة / مدير مباحث مطار الملك عبدالعزبز الدولي بجدة</div>
        </div>

        {/* Purpose Statement - Right aligned */}
        <div
          style={{
            textAlign: "right",
            fontSize: "16px",
            marginBottom: "15px",
            lineHeight: "1.8",
          }}
        >
          <div>نرغب في تصدير الارسالية التالية</div>
        </div>

        {/* Shipment Details - Right aligned */}
        <div
          style={{
            textAlign: "right",
            fontSize: "16px",
            marginBottom: "30px",
            lineHeight: "1.8",
          }}
        >
          <div>
            رقم البوليصة <b>{billOfLading}</b> العدد الطرود{" "}
            <b>{numberOfPackages}</b> ميزان <b>{weight}</b> الكيلو
          </div>
        </div>

        {/* Table */}
        <div style={{ marginTop: "20px" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid lightgray",
              direction: "rtl",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  مسلسل
                </th>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  الأصناف
                </th>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  الكمية
                </th>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  مسلسل
                </th>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  الأصناف
                </th>
                <th
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 6px",
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  الكمية
                </th>
              </tr>
            </thead>
            <tbody>
              {leftTableData.map((leftRow, index) => {
                const rightRow = rightTableData[index] || {
                  slNo: "",
                  description: "",
                  quantity: "",
                };

                return (
                  <tr key={index}>
                    {/* Left side columns */}
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      {leftRow.slNo}
                    </td>
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                        minHeight: "30px",
                      }}
                    >
                      <b>{leftRow.description}</b>
                    </td>
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      {isEditing ? (
                        <Input
                          value={leftRow.quantity}
                          onChange={(e) =>
                            handleLeftQuantityChange(index, e.target.value)
                          }
                          style={{
                            width: "60px",
                            textAlign: "center",
                            border: "none",
                            fontSize: "12px",
                            padding: "0",
                            height: "auto",
                            minHeight: "auto",
                            direction: "ltr",
                          }}
                          size="small"
                        />
                      ) : (
                        leftRow.quantity
                      )}
                    </td>
                    {/* Right side columns */}
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      {rightRow.slNo}
                    </td>
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      {rightRow.description}
                    </td>
                    <td
                      style={{
                        border: "1px solid lightgray",
                        padding: "6px 4px",
                        textAlign: "center",
                        fontSize: "12px",
                      }}
                    >
                      {isEditing ? (
                        <Input
                          value={rightRow.quantity}
                          onChange={(e) =>
                            handleRightQuantityChange(index, e.target.value)
                          }
                          style={{
                            width: "60px",
                            textAlign: "center",
                            border: "none",
                            fontSize: "12px",
                            padding: "0",
                            height: "auto",
                            minHeight: "auto",
                            direction: "ltr",
                          }}
                          size="small"
                        />
                      ) : (
                        rightRow.quantity
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
}

export default CommonPackingList;
